import { Platform } from 'react-native'
import log from './log'
import * as SecureStore from 'expo-secure-store'

declare const localStorage
declare const global

export class Storage {
  static async setItem(name: string, val: string): Promise<void> {
    if (global.window && Platform.OS === 'web') {
      localStorage.setItem(name, val)
    } else if (Platform.OS !== 'web') {
      await SecureStore.setItemAsync(name, val)
    } else {
      log.debug(`Storage api not available during SSR, cannot setItem ${name}`)
    }
  }

  static async getItem(name: string): Promise<string> {
    if (global.window && Platform.OS === 'web') {
      return localStorage.getItem(name)
    } else if (Platform.OS !== 'web') {
      return SecureStore.getItemAsync(name)
    } else {
      log.debug(`Storage api not available during SSR, cannot getItem ${name}`)
    }
  }

  static async deleteItem(name: string): Promise<void> {
    if (global.window && Platform.OS === 'web') {
      localStorage.removeItem(name)
    } else if (Platform.OS !== 'web') {
      await SecureStore.deleteItemAsync(name)
    } else {
      log.debug(`Storage api not available during SSR, cannot deleteItem ${name}`)
    }
  }
}

export default Storage